import React from 'react';

const About = () => {
  const stats = [
    {
      number: '60+',
      label: 'Countries Traveled',
      color: 'from-primary to-secondary',
    },
    {
      number: '5+',
      label: 'Years as Digital Nomad',
      color: 'from-secondary to-tertiary',
    },
    {
      number: '25+',
      label: 'Podcast Appearances',
      color: 'from-tertiary to-accent',
    },
    {
      number: '100%',
      label: 'Remote Team',
      color: 'from-accent to-primary',
    },
  ];

  return (
    <section id="about" className="bg-cream py-24">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Text Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-8">
              About Me
            </h2>
            <div className="space-y-6 text-lg text-gray-brown leading-relaxed">
              <p>
                For over 5 years, I lived as a digital nomad, traveling solo to 60+ countries
                while building and scaling MaidThis from the ground up. What started as an
                experiment in location independence became a 7-figure company
                with a fully remote team.
              </p>
              <p>
                MaidThis specializes in cleaning services for homeowners and short-term rental
                hosts (Airbnb, VRBO). We've perfected the art of running a local service business
                completely remotely—no office, no location constraints, just freedom and systems
                that work.
              </p>
              <p>
                Now based in Los Angeles, I'm sharing everything I've learned through
                MaidThis Franchise. We're helping ambitious entrepreneurs build their own
                location-independent cleaning businesses with proven systems, marketing support,
                and a blueprint for freedom.
              </p>
              <p className="font-semibold text-dark-brown">
                The goal? Help others achieve the same freedom and financial independence
                that transformed my life.
              </p>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="card-hover bg-white rounded-2xl p-8 shadow-crisp"
              >
                <div className={`text-5xl font-bold mb-3 bg-gradient-to-br ${stat.color} bg-clip-text text-transparent`}>
                  {stat.number}
                </div>
                <div className="text-gray-brown font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Additional Info Cards */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-crisp">
            <div className="w-12 h-12 bg-primary bg-opacity-20 rounded-xl flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2 text-dark-brown">Remote Business Expert</h3>
            <p className="text-gray-brown">
              Built and scaled a fully remote local service business to 7-figure revenue.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-crisp">
            <div className="w-12 h-12 bg-secondary bg-opacity-20 rounded-xl flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2 text-dark-brown">Location Independent Entrepreneur</h3>
            <p className="text-gray-brown">
              Explored 60+ countries as a solo backpacker while running a successful company.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-crisp">
            <div className="w-12 h-12 bg-accent bg-opacity-20 rounded-xl flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold mb-2 text-dark-brown">Franchise Mentor</h3>
            <p className="text-gray-brown">
              Helping entrepreneurs build their own location-independent businesses through franchising.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
